let cacheBusterEnabled = false;
let cacheBusterVersion = "";

const normalizeVersion = (value?: string | null): string => {
  if (!value) return "";
  return value.toString();
};

export function setAudioCacheBusterConfig(enabled: boolean, version?: string | null): void {
  cacheBusterEnabled = enabled;
  cacheBusterVersion = enabled ? normalizeVersion(version) : "";
}

export function getAudioCacheBusterConfig(): { enabled: boolean; version: string } {
  return { enabled: cacheBusterEnabled, version: cacheBusterVersion };
}

const appendQueryParam = (url: string, query: string): string => {
  if (!query) return url;
  if (url.includes("?")) {
    return `${url}&${query}`;
  }
  return `${url}?${query}`;
};

export function withAudioCacheBusterUrl(url: string): string {
  if (!cacheBusterEnabled || !cacheBusterVersion) return url;
  const query = `v=${encodeURIComponent(cacheBusterVersion)}`;
  return appendQueryParam(url, query);
}

export function withAudioCacheBuster(src: string[]): string[] {
  if (!cacheBusterEnabled || !cacheBusterVersion) return src;
  const query = `v=${encodeURIComponent(cacheBusterVersion)}`;
  return src.map((url) => appendQueryParam(url, query));
}
